module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedLight.228aa28.eot";